import type { StructuredContentRoot } from "@repo/app-types/content/structured/types";
import type { FC } from "react";
import { ExpandablePreview } from "../expandablePreview/expandablePreview.js";
import {
  renderStructuredContent,
  type StructuredContentRenderContext,
} from "../structuredContent/structuredContentRenderer.js";

export interface CoachingGoalBodyPreviewProps {
  /** The coaching note body (V3 AST); headings render as section labels. */
  content: StructuredContentRoot;
  /** Render context so grading references/quotes become interactive. */
  renderContext?: StructuredContentRenderContext;
  isExpanded: boolean;
  /** Keeps the body expanded and hides the collapse toggle (e.g. while the manager note editor is open). */
  isExpansionForced?: boolean;
  onExpandedChange: (isExpanded: boolean) => void;
}

export const CoachingGoalBodyPreview: FC<CoachingGoalBodyPreviewProps> = (
  props,
) => {
  const {
    content,
    renderContext,
    isExpanded,
    isExpansionForced,
    onExpandedChange,
  } = props;

  return (
    <ExpandablePreview
      isExpanded={isExpanded}
      isExpansionForced={isExpansionForced}
      onExpandedChange={onExpandedChange}
      collapsedHeight={128}
      fadeHeight={88}
      expandLabel="Continue reading"
      collapseLabel="Hide details"
      className="text-sm leading-6 text-foreground"
    >
      {renderStructuredContent(content, renderContext ?? {})}
    </ExpandablePreview>
  );
};
